import { css } from '@/styled-system/css';

export const reviewSectionStyles = css.raw({
  marginBottom: '800',
});

export const reviewTitleRowStyles = css.raw({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '400',
});

export const iconPlaceholderStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  marginRight: '200',
  width: '15px',
  flexShrink: 0,
});

export const reviewSectionTitleStyles = css.raw({
  display: 'flex',
  flexWrap: 'wrap',
  marginRight: '100',

  '& > *:not(:last-child)': {
    marginRight: '200 !important',
  },
});
